angular
	.module 'App.Component'
	.component 'tableFilter',
		{
			templateUrl: '@component/table/table-filter/table-filter.view.html'
			controller: 'TableFilterComponent'
			controllerAs: 'tableFilter'
			bindings:
				# Need to provide name, otherwise we would need to use `filter-d-t-o` in template
				filterDTO: '<filterDto'
				doInitialSearch: '<?'
				showInitialSearch: '<?'
				onSearch: '&'
				onBeforeAdvancedSearch: '&?'
				searchQueryProvider: '&?'
				searchFilterProvider: '&?'
		}

class TableFilterComponent extends AbstractController
	@register()
	@inject '$q',
		'$scope'
		'AdvancedSearchService'

	pageSizes: [
		10
		25
		50
		100
	]

	initialize: ->
		@$scope.$watch(
			'tableFilter.filterDTO'
			=>
				@onChanges()
			true
		)

		@advancedSearchEnabled = false
		@showAdvancedSearch = @showInitialSearch || false
		@pagesCount = null

		if !@filterDTO instanceof FilterDTO
			throw new Error("Parameter 'filterDTO' must be instance of FilterDTO, #{typeof @filterDTO} provided")

		if @filterDTO.searchConfiguration?
			@advancedSearchEnabled = true
			@advancedSearch = @AdvancedSearchService.initializeFilters(
				{
					configuration: @filterDTO.searchConfiguration
				},
				(filterKey) => return @_getAdvancedSearchValues(filterKey)
			)

		if @doInitialSearch
			@search()

	onChanges: ->
		@ensurePageSize()

		if @filterDTO.count?
			@pagesCount = Math.ceil(@filterDTO.count / @filterDTO.pageSize) || 1
		else
			@pagesCount = null

		# If we do not have total count or current page items count, we can't operate
		if !@filterDTO.count? && !@filterDTO.itemsCount?
			throw new Error('No page items count or total items count provided')

		@hasNextPage = (@pagesCount? && @filterDTO.page < @pagesCount) ||
			(@filterDTO.itemsCount? && @filterDTO.itemsCount == @filterDTO.pageSize)
		@hasPreviousPage = @filterDTO.page > 1

	ensurePageSize: ->
		if !@filterDTO.pageSize? || !@pageSizes.includes(@filterDTO.pageSize)
			@filterDTO.pageSize = @pageSizes[0]
			@search()

	toggleAdvancedSearch: ->
		if !@advancedSearchEnabled
			return

		@showAdvancedSearch = !@showAdvancedSearch

	resetAdvancedSearch: ->
		@AdvancedSearchService.reset(@advancedSearch)

	onAdvancedSearchChange: ->
		@AdvancedSearchService.onChange(@advancedSearch)

	search: (page = 1) ->
		@filterDTO.page = page

		if @searchQueryProvider?
			@filterDTO.query = @searchQueryProvider()
		else
			@filterDTO.query = new Query()

		if @advancedSearchEnabled
			@AdvancedSearchService.apply(@filterDTO.query, @advancedSearch)

		@onSearch()

	_getAdvancedSearchValues: (filterKey) ->
		if @searchFilterProvider?
			data = @searchFilterProvider({filterKey: filterKey})

			if data?
				return data
